'use strict';

const base = require('base:product/detail');
const attributesLogic = require('attributes');
const capencyHelper = require('capency/capencyHelper');
const capencyVerifyEmail = require('capency/capency/email/capency.verify.email');

/**
* Parses HTML and returns the body element
* @param {string} html - The HTML string to be parsed
* @returns {Object} - An object containing the body element
*/
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));
    var body = $html.find('.primary-images');
    return { body: body };
}

/**
* Fills the modal element with data from an AJAX call
* @param {string} selectedValueUrl - URL of the AJAX call
*/
function fillModalElement(selectedValueUrl) {
    $('.modal-body')
        .spinner()
        .start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('.modal-body')
                .empty()
                .html(parsedHtml.body);
            $('#detailImageModal').modal('show');
            $('body').trigger('detailimage:ready');

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
* Initializes the product detail logic
*/
function initProductDetailLogic() {
    $(function () {
        $('.attributes .attribute.toggle').on('click', attributesLogic.toggleAttribute);
        $('.attribute-values .circle-unselected').on('click', attributesLogic.selectAttributeValue);
    });
}

/**
* Validates a given name against a regex pattern
* @param {string} value - the name to validate
* @returns {boolean} - true if the name matches the regex pattern, false otherwise
*/
function valideName(value) {
    var nameRegex = /^[a-zA-ZΑ-Ωα-ωίϊΐόάέύϋΰήώáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ'-\s]{1,20}$/;
    return value.match(nameRegex);
}

/**
* Validates a text value
* @param {string} value - the text value to validate
* @returns {boolean} - true if the value is valid, false otherwise
*/
function valideText(value) {
    var textRegex = /^[^<>$;]{0,2000}$/;
    return value.match(textRegex);
}

/**
* Validates a given field and adds an error class if it is invalid
* @param {string} field - the field to be validated
* @param {boolean} shouldDisplayErrors - whether to display errors on form or not
* @returns {boolean} - whether the field is valid
*/
function validateField(field, shouldDisplayErrors) {
    var isValid = true;
    var $currentField = $(field);
    var currentFieldType = $currentField.attr('type');
    var currentFieldValue = $currentField.val();
    // do not validate capency fields
    if ($currentField.attr('data-validate-email') !== undefined) {
        return true;
    }

    const isEmpty = $currentField.hasClass('required') && (currentFieldValue.length === 0 || (currentFieldType === 'checkbox' && !$currentField.is(':checked')));
    const isTooHigh = $currentField.data('max') && parseFloat(currentFieldValue) > parseFloat($currentField.data('max'));
    const isTooLow = $currentField.data('min') && parseFloat(currentFieldValue) < parseFloat($currentField.data('min'));
    const isNotMatching = $currentField.data('confirm') && currentFieldValue !== $($currentField.data('confirm')).val();
    const nameIsNotValid = currentFieldType == 'text' && ((currentFieldValue.length > 20) || (currentFieldValue.length < 1) || (!valideName(currentFieldValue)));
    const textIsNotValid = $currentField.hasClass('textarea') && !valideText(currentFieldValue) && (currentFieldValue !== '');

    if (isEmpty || isTooHigh || isTooLow || isNotMatching || nameIsNotValid || textIsNotValid) {
        if (shouldDisplayErrors) {
            $currentField.addClass('is-invalid');
            if ($currentField.hasClass('textarea') && !valideText(currentFieldValue) && (currentFieldValue !== '')) {
                $('#form-name-textarea-error').show();
            } else {
                $('#form-name-textarea-error').hide();
            }
            if (currentFieldType == 'text' && (currentFieldValue.length > 20)) {
                $('#form-name-text-error').show();
                $('#form-name-code-error, #form-name-required-error').hide();
            } else if (currentFieldType == 'text' && (currentFieldValue.length < 1)) {
                $('#form-name-required-error').show();
                $('#form-name-code-error, #form-name-text-error').hide();
            } else if (currentFieldType == 'text' && !valideName(currentFieldValue)) {
                $('#form-name-code-error').show();
                $('#form-name-text-error, #form-name-required-error').hide();
            } else if (currentFieldType == 'number') {
                $('#form-name-amount-error').show();
            } else if (currentFieldType == 'email') {
                $currentField.next('.invalid-feedback').text($currentField[0].validationMessage).show();
            } else {
                $('#form-name-code-error, #form-name-text-error, #form-name-required-error, .invalid-feedback').hide();
            }
        }

        isValid = false;
    } else {
        $currentField.removeClass('is-invalid');
    }
    return isValid;
}

/**
* Validates the formular and enables/disables the addGiftCardToCartBtn
* @param {Object} form - the formular to be validated
* @param {boolean} shouldDisplayErrors - the impact of the validation
* @returns {boolean} - true if form is valid, false otherwise
*/
function validateFormular(form, shouldDisplayErrors) {
    var isValid = true;
    $.each($(form).find('.form-control, input[type="checkbox"]'), (key, field) => {
        if (!validateField(field, shouldDisplayErrors)) {
            isValid = false;
        }
    });
    if (isValid) {
        $('#addGiftCardToCartBtn').prop('disabled', false);
    } else {
        $('#addGiftCardToCartBtn').prop('disabled', true);
    }
    return isValid;
}

/**
* Clears the gift card form
* @param {Object} form - the form to be cleared
*/
function clearGiftCardForm(form) {
    $.each($(form).find('.form-control'), (key, field) => {
        $(field).val('');
    });
    validateFormular(form);
}
/**
* Hides the gift card form and clears its fields
* @param {Object} $addProductToCard - jQuery object for the add product to card form
*/
$('body').on('giftcard:afterAddToCart', function () {
    $('#giftcardform').modal('hide');
    clearGiftCardForm($('#addProductToCard'));
});

/**
* Event handler for add gift card form
* @param {Event} event - the event object
* @returns {void}
*/
$('body').on('submit', '#addProductToCard', function (event) {
    event.preventDefault();

    const $addGiftCardBtn = $(this);
    validateFormular(this, true);
    const giftCardAmount = $addGiftCardBtn.find('#giftCardAmount').val();
    const recipientName = $addGiftCardBtn.find('#recipientName').val();
    const $recipientEmail = $addGiftCardBtn.find('#recipientEmail');
    const recipientEmail = $recipientEmail.val();
    const recipientConfirmEmail = $addGiftCardBtn.find('#recipientConfirmEmail').val();
    const message = $addGiftCardBtn.find('#message').val();
    const pid = $addGiftCardBtn.find('#giftCardId').val();

    const args = {
        action: $addGiftCardBtn.attr('action'),
        method: $addGiftCardBtn.attr('method'),
        params: {
            giftCardAmount: giftCardAmount,
            recipientName: recipientName,
            recipientEmail: recipientEmail,
            recipientConfirmEmail: recipientConfirmEmail,
            pid: pid,
            message: message
        }
    };
    if (capencyHelper.isCapencyEnabled('email')) {
        capencyVerifyEmail.checkEmailPropertyResult($recipientEmail).then(function (result) {
            if (result && validateFormular($('#addProductToCard'), true)) {
                formSubmit.apply(null, [args]);
            }
        });
    } else {
        formSubmit.apply(null, [args]);
    }
});

/**
* Validates the formular and field
* @param {Object} $('#addProductToCard') - the formular to be validated
* @param {boolean} this - the field to be validated
* @param {boolean} true - flag to indicate whether the field should be validated
*/
$('body').on('change', '.form-control,input[type="checkbox"]', function () {
    validateFormular($('#addProductToCard'));
    validateField(this, true);
});

/**
* Validates the formular for adding a product to a gift card
* @param {Object} $('#addProductToCard') - jQuery selector for the formular
*/
$(document).ready(function () {
    validateFormular($('#addProductToCard'));
});

/**
* Submits a form using AJAX and triggers events based on the response
* @param {Object} args - An object containing action, method, and params for the AJAX request
* @param {string} args.action - The URL to send the AJAX request to
* @param {string} args.method - The HTTP method for the AJAX request
* @param {Object} args.params - The data to be sent with the AJAX request
* @returns {void}
*/
function formSubmit(args) {
    let { action, method, params } = args;
    $('body').trigger('product:beforeAddToCart', this);
    $.ajax({
        url: action,
        method: method,
        dataType: 'json',
        data: params,
        success: function (data) {
            let $form = $('#addProductToCard');
            if (data.success) {
                $('.minicart').trigger('count:update', data);
                $('body').trigger('product:afterAddToCart', data);
                $('body').trigger('giftcard:afterAddToCart');
                $form.find('.invalid-feedback').hide();
                $form.find('.is-invalid').removeClass('is-invalid');
            } else if (data.sMessage) {
                let $email = $('#recipientEmail', $form);
                $email.next('.invalid-feedback').text(data.sMessage).show();
            }
            $.spinner().stop();
        },
        error: function (error) {
            const jsonError = error.responseJSON || {};
            if (jsonError.success === false && jsonError.maxLimitError) {
                $('.gift-card-max-limit-reached-message').text(jsonError.maxLimitError);
            }
            $('#giftcardform').modal('hide');
            $.spinner().stop();
        }
    });
}

module.exports = {
    ...base,
    ...{
        initProductDetailLogic,
        /**
        * Handles the click event for the detail-image-modal class
        * @param {Object} e - the event object
        * @returns {void}
        */
        showProductDetailImageModal: function () {
            $('body').on('click', '.detail-image-modal', function (e) {
                e.preventDefault();
                var selectedValueUrl = $(this)
                    .closest('a.detail-image-modal')
                    .attr('href');
                $(e.target).trigger('detailimage:show');
                fillModalElement(selectedValueUrl);
            });
        }
    }
};
